 let sj_slider = document.querySelector('.sjScroll-wrapper-outer');
  	  let sj_innerSlider = document.querySelector('.sjScroll-wrapper');
      let sj_rightArrow = document.querySelector('.custom-arrow-right-sj');
      let sj_leftArrow = document.querySelector('.custom-arrow-left-sj');
      
      let sj_pressed = false;
      let sj_startx;
      let sj_x;
      
      
//         use this to disable sliders for *desktop safari browsers 

	  let userAgent = navigator.userAgent;
      let browserName;
      
    function fnBrowserDetect(){
                 
         
         
         if(userAgent.match(/chrome|chromium|crios/i)){
             browserName = "chrome";
           }else if(userAgent.match(/firefox|fxios/i)){
             browserName = "firefox";
           }  else if(userAgent.match(/safari/i)){
             browserName = "safari";
           }else if(userAgent.match(/opr\//i)){
             browserName = "opera";
           } else if(userAgent.match(/edg/i)){
             browserName = "edge";
           }else{
             browserName="No browser detection";
           }

  }
    
    fnBrowserDetect();
    


      //dragging

      //
   if (browserName !== 'safari'){
      sj_innerSlider.addEventListener('mousedown',(e)=>{

            e.preventDefault();

            sj_pressed = true;
            sj_startx = e.clientX;

       window.addEventListener('mouseup',()=>{

            sj_pressed = false;
                               
        });
     
     
            });

        sj_slider.addEventListener('mousemove',(e)=>{

            e.preventDefault();

            sj_x = e.clientX;
            let sj_scrolledValue = sj_startx - sj_x;



        if(!sj_pressed){ return}else{

          sj_innerSlider.scrollLeft += sj_scrolledValue;

        }

        });

     //end dragging
        
      }//end browser conditional
      
      sj_rightArrow.addEventListener('click', ()=>{
  
    	sj_innerSlider.scrollLeft += 350; 
        
        
      });
  
  
      sj_leftArrow.addEventListener('click', ()=>{
  
        if(sj_innerSlider.scrollLeft > 0){
    		sj_innerSlider.scrollLeft -=350;
      }else{return}
    	 
      });
      
       //dynamic arrow indication
  
  sj_innerSlider.addEventListener('scroll', function(e){
    
    let realWidth = sj_innerSlider.clientWidth; 
    
    //left
  
    if(sj_innerSlider.scrollLeft > 0 ){

      sj_leftArrow.classList.remove("hde");
    }else{
      sj_leftArrow.classList.add("hde");
    }
    
     //right
    if(sj_innerSlider.scrollLeft + realWidth > sj_innerSlider.scrollWidth - 50){
    
      sj_rightArrow.classList.add("hde");
    }else{
    
      sj_rightArrow.classList.remove("hde");
    }
    
  })
  
  //end dynamic arrow indicators 